export default function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@babel_runtime@7.23.9@@babel/runtime/helpers/esm/isNativeReflectConstruct.js
// module id = null
// module chunks = 